import type { OAuthConfig } from './config.js';
import { MCPOAuthClientProvider } from './index.js';

/**
 * Factory function to create an OAuth client provider
 *
 * @example
 * ```typescript
 * const provider = createOAuthProvider({
 *   redirectUri: 'http://localhost:8080/callback',
 *   scope: 'openid profile email',
 * });
 * ```
 */
export function createOAuthProvider(
  config: OAuthConfig
): MCPOAuthClientProvider {
  return new MCPOAuthClientProvider(config);
}
